module.exports = __webpack_public_path__ + "img/05.94a2ab88.webp";